import React, { ChangeEvent } from 'react';
import SuffixedInput from './suffixed-input';

interface StepInputProps {
    valueFormatter?: (value: number) => string;
    label: string;
    value: number;
    minValue: number;
    maxValue: number;
    stepSize: number;
    suffix: string;
    onChange: (value: number) => void;
    style?: React.CSSProperties;
    incrementValueText: string;
    decrementValueText: string;
}

const StepInput = (props: StepInputProps) => {
    const incrementValue = () => {
        props.onChange(Math.min(props.maxValue, props.value + props.stepSize));
    };

    const decrementValue = () => {
        props.onChange(Math.max(props.minValue, props.value - props.stepSize));
    };

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const {
            target: { value }
        } = e;
        const intValue = parseInt(value, 10);
        if (intValue < props.maxValue + 1 && intValue > props.minValue - 1) {
            props.onChange(intValue);
        } else if (Number.isNaN(intValue)) {
            props.onChange(0);
        } else if (intValue > props.maxValue) {
            props.onChange(props.maxValue);
        }
    };

    return (
        <div className="step-input-container">
            <SuffixedInput
                label={props.label}
                value={props.value}
                suffix={props.suffix}
                onChange={onChange}
                style={props.style}
                valueFormatter={props.valueFormatter}
            />
            <button
                type="button"
                className="circle-button"
                onClick={decrementValue}
                aria-label={props.decrementValueText}
            >
                <i className="ikon-minus-24" />
            </button>
            <button
                type="button"
                onClick={incrementValue}
                className="circle-button"
                aria-label={props.incrementValueText}
            >
                <i className="ikon-pluss-24" />
            </button>
        </div>
    );
};

export default StepInput;
